module.exports = __webpack_public_path__ + "img/text-title.f4e758a7.svg";